import { Alert, Button, Snackbar } from '@mui/material'
import { useI18n } from '@tm/client-app/src/i18n'
import { useState } from 'react'
import { useAppVersion } from './useAppVersion'

/**
 * Offers a reload to tabs left open across a deploy. Deliberately not a
 * forced reload: the tab may hold an unsent form.
 *
 * MUI's Alert only renders its built-in close button when `onClose` is
 * given and no custom `action` is supplied, so the Reload button lives in
 * the alert's children instead of `action` to keep the real close icon.
 */
export function UpdatePrompt() {
  const { t } = useI18n()
  const { updateAvailable, reload } = useAppVersion()
  const [dismissed, setDismissed] = useState(false)

  const open = updateAvailable && !dismissed

  // Unmount outright on dismiss instead of letting Snackbar animate itself out.
  // That drops the exit animation in the browser, and in jsdom it is the only
  // way the alert leaves the DOM at all: the exit transition waits for a
  // transitionend that never fires there.
  if (!open) return null

  return (
    <Snackbar open anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}>
      <Alert severity="info" onClose={() => setDismissed(true)}>
        {t('app.updateAvailable.text')}{' '}
        <Button color="inherit" size="small" onClick={reload}>
          {t('app.updateAvailable.action')}
        </Button>
      </Alert>
    </Snackbar>
  )
}
